/** HID Global addresses only. The domain must be exact, in any letter case. */

export const HID_EMAIL_MESSAGE =
  "Only HID Global email addresses (@hidglobal.com) are permitted.";

export function isHidGlobalEmail(value: string): boolean {
  const email = value.trim();
  const at = email.lastIndexOf("@");
  if (at <= 0 || at !== email.indexOf("@")) return false;
  return email.slice(at + 1).toLowerCase() === "hidglobal.com";
}
